import { useEffect } from 'react';

export const useScrollAnimation = () => {
  useEffect(() => {
    if (!('IntersectionObserver' in window)) return;

    const prefersReduced = window.matchMedia
      && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced) return;

    // Elementos que entram deslizando (sem hover/transform próprio)
    const slideSelectors = [
      '.mgs-symptoms__head', '.mgs-symptoms__pill',
      '.mgs-gym__title', '.mgs-gym__desc',
      '.mgs-imagine__title',
      '.mgs-experts__title', '.mgs-experts__video',
      '.mgs-reviews__title',
      '.mgs-offer__title', '.mgs-offer__subtitle',
      '.mgs-results__title', '.mgs-results__subtitle',
      '.mgs-buy__title',
      '.mgs-faq__title',
      '.section-six-text'
    ].join(',');

    // Elementos que só fazem fade (têm hover/transform ou são imagens full-bleed)
    const fadeSelectors = [
      '.mgs-reviews__card', '.mgs-offer__card', '.mgs-buy__step',
      '.mgs-symptoms__row', '.mgs-imagine__item',
      '.mgs-gym__image', '.mgs-imagine__image', '.mgs-symptoms__photo',
      '.mgs-buy__arrow', '.story-img'
    ].join(',');

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('reveal-in');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    const prepare = (selector, type) => {
      document.querySelectorAll(selector).forEach((el) => {
        el.setAttribute('data-reveal', type);
        observer.observe(el);
      });
    };

    prepare(slideSelectors, 'slide');
    prepare(fadeSelectors, 'fade');

    // Efeito escalonado (stagger) para itens em grade/lista
    const staggerGroups = [
      '.mgs-reviews__grid', '.mgs-offer__grid', '.mgs-symptoms__list',
      '.mgs-buy__steps', '.mgs-faq__list', '.mgs-imagine__list'
    ];
    staggerGroups.forEach((groupSel) => {
      document.querySelectorAll(groupSel).forEach((group) => {
        Array.from(group.children).forEach((child, i) => {
          if (child.hasAttribute('data-reveal')) {
            child.style.transitionDelay = `${Math.min(i, 6) * 0.08}s`;
          }
        });
      });
    });

    return () => observer.disconnect();
  }, []);
};
